<template>
  <fn-panel
    :headline="title || $t('login.knowUserTitle')"
    :no-padding-x="noPaddingX"
    padded
    constrained
  >
    <slot name="before" />

    <fn-vuex-form-login
      :redirect-to="redirectTo"
      :email="email"
      :salon="salon"
    />

    <slot name="after" />
  </fn-panel>
</template>

<script lang="ts">
export default defineComponent({
  props: {
    redirectTo: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    noPaddingX: {
      type: Boolean,
    },
    salon: {
      type: Boolean,
    },
  },
});
</script>
